import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import RegisterTemplate from '@components/Register/Register';
import useTranslation from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';
import { publicAssets } from '@utils/url.utils';
import { IS_PROD } from '../constants';

interface IRegister {}

const Register: NextPage<IRegister> = () => {
    const { t } = useTranslation();

    return (
        <>
            <NextSeo
                title={t('seo.registration.title')}
                description={t('seo.registration.description')}
                noindex={!IS_PROD}
                nofollow={!IS_PROD}
                openGraph={{
                    images: [{ url: `https://profivzdelavanie.sk${publicAssets('/og-konferencia.png')}` }],
                }}
            />
            <HeaderTemplate />
            <ContentTemplate withPadding>
                <RegisterTemplate />
            </ContentTemplate>
            <FooterTemplate />
        </>
    );
};

export default Register;
